import { HttpErrorResponse } from "@angular/common/http";

export const createEvent = (events: any ) => {
let calendar = `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Events Calendar
BEGIN:VEVENT
DTSTAMP:${toTimestampFormat(new Date())}
DTSTART;TZID=America/${events.timezone }:${toTimestampFormat(events.appointment.start)}
DTEND;TZID=America/${events.timezone}:${toTimestampFormat(events.appointment.end)}
SUMMARY:${events.title}
DESCRIPTION:${events.description}
LOCATION:${events.location}
TRANSP:OPAQUE
X-MICROSOFT-CDO-BUSYSTATUS:BUSY
CLASS:PUBLIC
BEGIN:VALARM
ACTION:DISPLAY
DESCRIPTION:${events.description}
TRIGGER:-PT30M
END:VALARM
BEGIN:VALARM
ACTION:DISPLAY
DESCRIPTION:${events.description}
TRIGGER:-P1D
END:VALARM
END:VEVENT
END:VCALENDAR`
  return calendar
}

export const download = (filename:string, text:string) => {
  const element = document.createElement('a');
  element.setAttribute(
    'href',
    'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
  );
  element.setAttribute('download', filename);
  element.setAttribute('target', '_blank');
  element.style.display = 'none';
  element.click();
};

export const toTimestampFormat = (date: Date): string => {
  const pad = (n: number) => n.toString().padStart(2, '0');

  return (
    date.getUTCFullYear().toString() +
    pad(date.getUTCMonth() + 1) +
    pad(date.getUTCDate()) +
    'T' +
    pad(date.getUTCHours()) +
    pad(date.getUTCMinutes()) +
    pad(date.getUTCSeconds()) +
    'Z'
  );
}

export const setErrorMessage  = (err: HttpErrorResponse, dataName?: string):string => {
  let errorMessage = '';
  let name = dataName ?? '';
  if (err) {
     if (err.error instanceof ErrorEvent) {
        errorMessage = `An error occurred: ${err.error.message}`;
     } else {
        const status = err.status;
        if (status === 401) errorMessage = `You are not authorized to access ${name} data.`;
        if (status === 404) errorMessage = `${name} data was not found. Please try again later.`;
        if (status > 500 && status < 600) errorMessage = `The server isn't currently working. Please try again later.`;
     }
  }
  return errorMessage;
}